{
  "fr": {
    "subscriptions": {
      "plans": {
        "free": {
          "title": "Créez un compte gratuit"
        },
        "courses": {
          "title": "Abonnement illimité aux formations",
          "subtitle": "Accès complet à toutes les formations fobizz.",
          "features": "<li><i class='bi bi-check-lg'></i><div>Accès au catalogue complet des formations</div></li><li><i class='bi bi-check-lg'></i><div>Accès à toutes les enregistrements de webinaires</div></li><li><i class='bi bi-check-lg'></i><div>Exercices pratiques et matériel inclus</div></li><li><i class='bi bi-check-lg'></i><div>Toutes les formations avec certificat</div></li>"
        },
        "tools": {
          "title": "Abonnement illimité aux outils",
          "subtitle": "Accès illimité aux outils fobizz et à l'assistance IA pour l'enseignement.",
          "features": "<li><i class='bi bi-check-lg'></i><div>Utilisation illimitée de tous les outils numériques</div></li><li><i class='bi bi-check-lg'></i><div>Accès illimité aux salles de classe IA</div></li><li><i class='bi bi-check-lg'></i><div>Création illimitée de vos propres assistants IA et chatbots</div></li><li><i class='bi bi-check-lg'></i><div>Aucune inscription des élèves nécessaire</div></li>"
        },
        "combined": {
          "title": "Abonnement combiné",
          "subtitle": "Accès complet à toutes les formations, outils et assistance IA.",
          "badge": "Populaire",
          "features": "<li><i class='bi bi-check-lg'></i><div>Tous les avantages des licences de formation et d'outils</div></li><li><i class='bi bi-check-lg'></i><div>Économisez 25% par rapport au prix individuel</div></li><li><i class='bi bi-check-lg'></i><div>Accès au catalogue complet des formations</div></li><li><i class='bi bi-check-lg'></i><div>Utilisation illimitée de tous les outils numériques, y compris l'IA</div></li>"
        },
        "pricing_card": {
          "year": "Année",
          "month": "Mois",
          "buy_now": "Acheter maintenant",
          "checkout_error": "Une erreur est survenue lors de l'ouverture du checkout. Veuillez réessayer plus tard."
        }
      }
    }
  }
}
